import { pageSizes, pickerOptions, GENDER_OPTOINS } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import { startDate } from '@/utils/filter';

export default {
  name: 'wait-fee',
  mixins: [pageSize],
  data() {
    return {
      pageSizes,
      pickerOptions,
      tableData: [],
      total: 0, // 总数据条数
      time: [],
      query: {
        doctorId: -1,
        patient: '', // 患者姓名
        startTime: '',
        endTime: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
      doctorOptions: [{
        doctorId: -1,
        realName: '全部',
      }],
    };
  },
  methods: {
    // 刷新列表数据
    refresh() {
      this.getTableData();
    },
    // 获取列表信息
    getTableData() {
      this.query.startTime = this.time ? this.time[0] : '';
      this.query.endTime = this.time ? this.time[1] : '';
      this.$api.feeDispense.pendingOrder(this.query).then((res) => {
        // 后端数据进行筛选
        this.tableData = res.order.map(item => ({
          patientName: item.patient.patientName,
          gender: item.patient.gender,
          age: `${item.inquiryInfo.age ? item.inquiryInfo.age : ''}${item.inquiryInfo.ageType ? item.inquiryInfo.ageType : ''}`,
          diagnosisResultString: item.inquiryInfo.diagnosisResultString,
          clinicalTime: item.inquiryInfo.clinicalTime,
          doctor: item.realName,
          receivableAmt: item.receivableAmt,
          id: item.id,
          clinicalAge: item.inquiryInfo.clinicalAge,
        }));
        this.total = res.totalSize;
      });
    },
    // 获取诊所医生
    getDoctorId(queryString, cb) {
      this.$api.drugControl.drugsNameList({
        drugName: this.query.drugName,
      }).then((res) => {
        console.log(res);
      });
    },
    // 跳转待收费详情
    gotoWaitFeeDetail(item) {
      this.$router.push({ name: 'waitFeeDetail', query: { id: item.id } });
    },
    // 每页展示数据条数变更
    handleSizeChange() {
      this.getTableData();
    },
    // 翻页
    handleCurrentChange() {
      this.getTableData();
    },
    // 获取医生信息
    getDoctor() {
      this.$api.outPatient.getHospitalDoctor().then((res) => {
        // 先做默认第一个 后期本地存储一下
        this.doctorOptions = this.doctorOptions.concat(res);
      });
    },
    doctorChange() {
      this.getTableData();
    },
  },
  mounted() {
    this.time = startDate(); // 设置默认日期
    // console.log(this.time);
    this.getDoctor();
    this.getTableData();
  },
};
